function getCurrentYear(): string {
  return new Date().getFullYear().toString();
}

export default getCurrentYear;